import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Alert,
  Chip,
  Stack,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DescriptionIcon from "@mui/icons-material/Description";
import PageWrapper from "./layout/PageWrapper";

const AdminLogs = (props) => {
  const {
    logs,
    lines,
    since,
    container,
    loading,
    error,
    onRefreshLogs,
    onLinesChange,
    onSinceChange,
  } = props;

  return (
    <PageWrapper>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <DescriptionIcon /> Logs Serveur
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Consultez les logs du serveur en temps réel
        </Typography>
      </Box>

      {/* Contrôles */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Nombre de lignes</InputLabel>
            <Select
              value={lines || ""}
              label="Nombre de lignes"
              onChange={(e) => onLinesChange(e.target.value)}
              disabled={!!since}
            >
              <MenuItem value={50}>50 lignes</MenuItem>
              <MenuItem value={100}>100 lignes</MenuItem>
              <MenuItem value={200}>200 lignes</MenuItem>
              <MenuItem value={500}>500 lignes</MenuItem>
              <MenuItem value={1000}>1000 lignes</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Période</InputLabel>
            <Select
              value={since || ""}
              label="Période"
              onChange={(e) => onSinceChange(e.target.value)}
            >
              <MenuItem value="">Aucune</MenuItem>
              <MenuItem value="5m">5 dernières minutes</MenuItem>
              <MenuItem value="10m">10 dernières minutes</MenuItem>
              <MenuItem value="30m">30 dernières minutes</MenuItem>
              <MenuItem value="1h">1 dernière heure</MenuItem>
              <MenuItem value="2h">2 dernières heures</MenuItem>
              <MenuItem value="6h">6 dernières heures</MenuItem>
              <MenuItem value="12h">12 dernières heures</MenuItem>
              <MenuItem value="24h">24 dernières heures</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            startIcon={
              loading ? <CircularProgress size={20} /> : <RefreshIcon />
            }
            onClick={onRefreshLogs}
            disabled={loading}
            sx={{ height: 56 }}
          >
            Actualiser
          </Button>
        </Stack>

        {container && (
          <Box sx={{ mb: 2 }}>
            <Chip
              label={`Conteneur: ${container}`}
              color="primary"
              variant="outlined"
              size="small"
            />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
      </Paper>

      {/* Zone des logs */}
      <Paper sx={{ p: 0, backgroundColor: "#1e1e1e", minHeight: 400 }}>
        {loading && !logs ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 400,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <TextField
            multiline
            fullWidth
            value={logs || "Aucun log disponible"}
            InputProps={{
              readOnly: true,
              sx: {
                fontFamily: "monospace",
                fontSize: "0.875rem",
                color: "#d4d4d4",
                backgroundColor: "#1e1e1e",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                padding: 2,
              },
            }}
            minRows={20}
            maxRows={50}
          />
        )}
      </Paper>

      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {logs ? `${logs.split("\n").length} lignes affichées` : "0 ligne"}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Dernière actualisation: {new Date().toLocaleString("fr-FR")}
        </Typography>
      </Box>
    </PageWrapper>
  );
};

export default AdminLogs;
